'use strict';

const Header = {
    el: null,
    toggle: null,
    lastScrollY: 0,
    isSticky: false,

    init: function () {
        Header.el = document.querySelector('.header');

        if (Header.el) {
            Header.toggle = Header.el.querySelector('.header__toggle');
            if (Header.toggle) {
                Header.toggle.addEventListener('click', () => {
                    Header.el.classList.toggle('navOpened');
                    document.body.classList.toggle("no-scroll");
                });
            }

            // Initialize sticky behavior
            Header.addScrollListener();
        }
    },

    addScrollListener: function () {
        window.addEventListener('scroll', () => {
            const currentScrollY = window.scrollY;
            if (currentScrollY > 0) {
                if (!Header.isSticky) {
                    Header.el.classList.add('sticky--');
                    Header.isSticky = true;
                }
            } else {
                Header.el.classList.remove('sticky--');
                Header.isSticky = false;
            }
        });
    },
};

export default Header;
